import {DocumentNode, gql} from "@apollo/client";

export const SWEEP_PAYOUT_MUTATION: DocumentNode = gql(`
    mutation SweepPayoutOperation($operationId: Float!) {
        sweepPayoutOperation(operationId: $operationId) {
            message
        }
    }
`);
